import constant from '../../constant'

const initialState = { 
  hotRank: []
};

export function search (state = initialState, action) {
  switch (action.type) {
    case constant.SEARCH.GET_HOT_RANK:
      return {
        ...state,
        ...action
      }
    default:
      return state
  }

}